<ngx-layout
  (orderIdEvent)="emitOrderIdEvent($event)"
  (settingsEvent)="goSettings()"
  [phoneNumber]="phoneNumber"></ngx-layout>
